import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { createSupabaseClient } from "@/lib/supabase.server";
import { Form } from "@remix-run/react";
import { ActionFunctionArgs, LoaderFunctionArgs, redirect } from "@remix-run/server-runtime";
import { jwtDecode } from 'jwt-decode'

// export async function loader({request}: LoaderFunctionArgs){
//     const {supabaseClient} = createSupabaseClient(request, true);

//     const session = (await supabaseClient.auth.getSession()).data.session;
//     if(session){
//         return(redirect('/'))
//     }

//     return null;
    
// }

export async function action({request}: ActionFunctionArgs){
    const form = await request.formData();
    const {supabaseClient, headers} = createSupabaseClient(request, true);

    const { error } = await supabaseClient.auth.signInWithPassword({
        email: form.get("email") as string,
        password: form.get("password") as string,
      });

    if (error) {
        console.log(error);
        return null;
    }

    const session = (await supabaseClient.auth.getSession()).data.session;
    if(session){
        const jwt = jwtDecode(session.access_token)
            const userRole = jwt.user_role;
            console.log(jwt);
            console.log('the role of the user is: ', userRole)
            if(userRole === 'admin'){
                console.log('goign to admin!')
                return(redirect('/', {headers}))
            } 
            else {
                console.log('signing out!')
                await supabaseClient.auth.signOut();
                return redirect('/', {headers})
            }
    }

    console.log("hi sexy admin");
    return redirect('../', {headers})
    
}

export default function Login(){

    return(
        <div className="w-full flex-1 flex justify-center">
            <div className="flex flex-col gap-2 self-center text-center w-[400px]">
                <img src="/morby_icon.svg" className="w-[35.77px] self-center h-[40.5px]"/>
                <h1 className="text-xl">Admin</h1>

                <Form method="post" className="flex flex-col gap-4">
                    <Input placeholder="Email" name="email"/>
                    <Input placeholder="Password" type="password" name="password"/>
                    <Button type="submit" variant="secondary" className="bg-[#7F56D9] hover:bg-purple-800">Login</Button>
                </Form>
            </div>
        </div>
    )
}